import Alpine from 'alpinejs';
import DataLayer from './components/data-layer';
import StoreCookies from './components/store-cookies';
import isLogged from './components/is-logged';

window.Alpine = Alpine;

Alpine.store('auth', {
    isLoggedIn: false,

    async checkAuth() {
        const response = await fetch('/check-cookies');
        const data = await response.json();
        this.isLoggedIn = data.isLoggedIn;
    }
});

Alpine.store('auth').checkAuth();

window.Alpine = Alpine;

Alpine.data('dataLayer', DataLayer);
Alpine.data('isLogged', isLogged);
Alpine.data('storeCookies', StoreCookies);

Alpine.start();
